<template>
    <el-menu mode="vertical" theme="dark" :unique-opened="true" :default-openeds="defaultOpeneds" :default-active="$route.path">
        <sidebar-item :routes='permission_routers'></sidebar-item>
    </el-menu>
</template>

<script>
    import { mapGetters } from 'vuex';
    import SidebarItem from './SidebarItem';
    export default {
      components: { SidebarItem },
      computed: {
        ...mapGetters([
          'permission_routers'
        ])
      },
      data(){
        return{
          defaultOpeneds:[],
        }
      },
      created:function(){
        var arr = [];
        this.permission_routers.forEach((item,index)=>{
            if(!item.hidden){
              arr.push(item);
            }

        });

        this.defaultOpeneds.push(arr[0].key);
      }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-menu {
    min-height: 100%;
}

.sidebar-wrapper{
   overflow:hidden;
}

</style>



// WEBPACK FOOTER //
// Sidebar.vue?84aa1186